Page contractPage
	title = "Kaufvertrag"
	needsAuth = true

	hasHeaderAndFooter = false
	Good good
	User buyer, seller
	bool showPrintButton = true
	
	show: string id
		good = await app.goods.fetchById id
		if not good or not good.buyer or (good.state != Sold and good.state != PickedUp) or (good.seller != app.user.id and good.buyer != app.user.id and app.user.userType != Admin)
			app.navigateTo homePage; return
		html.setTitle "{title} {good.Marke} {good.Modell}" + app.titleSuffix
		buyer  = await backend.users.fetchById good.buyer
		seller = await backend.users.fetchById good.seller
		showPrintButton = true

	printInvoice
		showPrintButton = false
		refresh
		Platform.openPrintDialog
		showPrintButton = true
		refresh

	draw
		if not good  or not buyer or not seller then return
		string text = app.getText("contract")
		..replaceAll '{TYP}'	with good.Typ
		..replaceAll '{VERTRAGSDATUM}'	with good.sellDate.dayMonthNameYearString || "(bitte eintragen)"
		..replaceAll '{VERTRAGS_ID}'	with good.id
		..replaceAll '{VERKAEUFER_NAME}'	with seller.name
		..replaceAll '{VERKAEUFER_ADRESSE}'	with "{seller.streetAddress}, {seller.zipCode} {seller.city}, {seller.country}"
		..replaceAll '{VERKAEUFER_TEL}'	with seller.phoneNumber
		..replaceAll '{VERKAEUFER_EMAIL}'	with seller.email
		..replaceAll '{VERKAEUFER_TYPE}'	with app.userTypeNames[seller.userType]
		..replaceAll '{KAEUFER_FIRMA}'	with buyer.businessName
		..replaceAll '{KAEUFER_VERTRETUNG}'	with "{buyer.firstName} {buyer.lastName}"
		..replaceAll '{KAEUFER_ADRESSE}'	with "{buyer.streetAddress}, {buyer.zipCode} {buyer.city}, {buyer.country}"
		..replaceAll '{KAEUFER_TEL}'	with buyer.phoneNumber
		..replaceAll '{KAEUFER_EMAIL}'	with buyer.email
		..replaceAll '{HAENDLER_ID}'	with buyer.id
		..replaceAll '{FAHRZEUG_TITEL}'	with "{good.Marke} {good.Modell}"
		..replaceAll '{VERFUEGBARKEIT}'	with good.readyForPickupTime?.dayMonthNameYearString || "sofort"
		..replaceAll '{KAUFPREIS}'	with good.currentPrice.currencyString
		..replaceAll '{UST_HINWEIS}'	with good.Umsatzsteuer
		
		if showPrintButton
			column alignItems:center margin:{16 0 16 0}
				app.button "Drucken", onClick:printInvoice
		div text width:960px

		html.setChildrenOf "goodProfile"
			let fields = app.fields.where.showInAuctionPageTable and .showOnEditPage and .showFor.contains(good.Typ)
			fields.orderBy.viewOrder
			fields.eachDistinct.section as section, items
				if section == "Preis & Standort" then return
				column marginBottom:24
					div fontSize:20, text:section, borderBottom:{2px solid #d0d0d0}
					switch section
						"Beschreibung"
							div good[items.first.fieldName]
						"Ausstattung"
							string str = (items.where good[.fieldName]).joinToString.name
							div str
						default
							if section != "Preis & Standort"
								grid gridTemplateColumns:"1fr 2fr" border:{1px solid #e5e7eb} borderRadius: 14px
									for items
										div .name padding:{10px 12px} borderBottom:{1px solid #e5e7eb} backgroundColor:#f9fafb fontWeight: bold
										let valueString = good[.fieldName]
										if .dataType == "toggle" then valueString = valueString ? "Ja" : "Nein"
										div "{valueString} {.unit}" padding:{10px 12px}
